import { css } from '@emotion/core'
import { colors, spacing } from 'styles/variables'

export const container = css`
  padding: ${spacing(2)};
  background-color: ${colors.black};
  min-height: 100vh;
`

export const teamsGrid = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${spacing(1)};
  width: 100%;
`

export const loadingPlaceholder = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
`

export const loadingText = css`
  color: ${colors.white100};
`

export const errorContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: ${colors.red};
`

export const emptyContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: ${colors.white100};
` 